'use es6';

import { createSelector } from 'reselect';

const getFeaturedCalloutsListings = state => state.featuredCallouts.listings;

export const getFeaturedCalloutsRequestState = state => state.featuredCallouts.requestState;
export const getDisplayedFeaturedCalloutListings = createSelector([getFeaturedCalloutsListings], listings => listings.take(2));